import React, { useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import CheckboxField from "../../../components/Fields/CheckboxField";
import SelectListField from "../../../components/Fields/SelectListField";
import TextareaField from "../../../components/Fields/TextareaField";
import TextboxField from "../../../components/Fields/TextboxField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import DataService from "../../../services/data.service";
import { PopupProps } from "../../../types/PopupProps";
import { DataResult } from "../../../types/Result";

interface Props extends PopupProps {
    workflowDefinitionId
}

interface WorkflowStepDefinitionCreateModel {
    workflowDefinitionId: number
    title: string
    description: string
    isFirstStep: boolean
}

const AddWorkflowStep: React.FC<Props> = ({ show, onHide, workflowDefinitionId }) => {
    const workflows = useSelectListOptions('api/v1/selectlist/WorkflowDefinitions', '-- Select workflow');
    const [serverErrors, setServerErrors] = useState<DataResult<WorkflowStepDefinitionCreateModel>>({ isSuccesful: true, messages: [], data: undefined });
    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<WorkflowStepDefinitionCreateModel>({
        workflowDefinitionId: workflowDefinitionId,
        title: '',
        description: '',
        isFirstStep: false,
    });

    function submit() {
        if (formData) {
            DataService
                .create<WorkflowStepDefinitionCreateModel>(`api/v1/WorkflowStepDefinitions/`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true && response.data)
                        onHide()
                })
                .catch(e => handleException(e));
        }
    }

    function onFieldChanged(name: string, value: string): void {
        if (formData) {
            formData[name] = value;
            setFormData(formData);
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'title', label: 'Title', validationRules: [{ type: 'isRequired' }] },
            { name: 'subWorkflowDefinitionId', label: 'Sub-workflow' },
            { name: 'isFirstStep', label: 'First step' },
            { name: 'description', label: 'Description' },
        ],
        handleSubmit: submit,
        handleFieldChanged: onFieldChanged,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Add step'} >
            <Popup.Body>
                <TextboxField {...getFieldProps('title')} />
                <SelectListField {...getFieldProps('subWorkflowDefinitionId')} options={workflows} />
                <CheckboxField {...getFieldProps('isFirstStep')} />
                <TextareaField {...getFieldProps('description')} rows={8} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} text='Add' />
            </Popup.Footer>
        </Popup>
    );
}
export default AddWorkflowStep;